import { render, staticRenderFns } from "./CartAddressItem.vue?vue&type=template&id=31959eb1&scoped=true"
import script from "./CartAddressItem.vue?vue&type=script&lang=js"
export * from "./CartAddressItem.vue?vue&type=script&lang=js"
import style0 from "./CartAddressItem.vue?vue&type=style&index=0&id=31959eb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31959eb1",
  null
  
)

export default component.exports